import { Toast } from 'common/Toast/Toast'
import { ToastHeader } from 'common/Toast/ToastHeader'
import { ReactComponent as FocusIcon } from 'assets/icons/focus__16.svg'
import { Button } from 'components/Button'

import Styles from './FocusModeToast.module.scss'

export const FocusModeToast = ({ onClose }: { onClose: () => void }) => {
  return (
    <Toast position="bottomLeft" className={Styles.fadeIn}>
      <ToastHeader icon={FocusIcon} title="Focus mode" onClose={onClose} />

      <div>
        While Focus Mode is on, the interface disappears as you type. This feature can be turned off in settings.
        <div className={Styles.focusModeToastFooter}>
          <Button size="md" onPress={onClose}>
            Got it
          </Button>
        </div>
      </div>
    </Toast>
  )
}
